import React,{Component} from 'react';
import './Contact.css';

import { 
    contactBackground, logo
} from '../../_utils/images';
import routes from '../../_utils/routes';
import Page from '@acri-tools/react-tools/components/Page/Page';

interface MyProps{
    history?:any,
}

class Contact extends Component<MyProps,{}>{
    render(){
        return (
        <Page 
            id="contact"
            title="contact"
            banner={{
                bannerImage: contactBackground,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
            </div>
        </Page>
        );
    }

};


// export default App;
export default (Contact);
